import React from 'react';
import TeacherAccount from '../containers/TeacherAccount';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider'

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <TeacherAccount {...props} />
  </DemoAccountContextProvider>
);
